import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { setEntity } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { patchErrorRequestStatus, setSubmitFulfilled, setSubmitPending, withRequestStatus } from '@pflegix/store';
import { UpdateOrderDto } from '@pflegix/types';
import { ToastService } from '@pflegix/ui';
import { lastValueFrom, pipe, tap } from 'rxjs';
import { OrderStore } from '../../store';
import { OrderUpdateApi } from '../api/order-update.api';

export const OrderUpdateStore = signalStore(
  { protectedState: false },
  withDevtools('order-update'),
  withState<{
    id: string | undefined;
  }>({ id: undefined }),
  withRequestStatus(),
  withComputed((store, orderStore = inject(OrderStore)) => {
    const order = computed(() => orderStore.entityMap()[store.id() ?? '']);

    return {
      order,
    };
  }),
  withMethods(
    (store, api = inject(OrderUpdateApi), orderStore = inject(OrderStore), toastService = inject(ToastService)) => ({
      setOrderId: rxMethod<string>(pipe(tap((id) => patchState(store, { id })))),
      updateOrder: async (dto: UpdateOrderDto): Promise<void> => {
        const id = store.id();

        if (!id) {
          return;
        }

        patchState(store, setSubmitPending());

        try {
          const order = await lastValueFrom(api.update(id, dto));

          toastService.addSuccessToast('Daten erfolgreich aktualisiert');

          patchState(orderStore, setEntity(order, { selectId: (entity) => entity._id }));
        } catch (error) {
          patchErrorRequestStatus(store, error);
        } finally {
          patchState(store, setSubmitFulfilled());
        }
      },
    })
  )
);
